import { capitalize } from 'lodash-es';
import { routes } from '~/constants';
import { TaxWorkflow } from '~/types/api.model';
export function getManageIntegrationRoute(integration) {
    switch(integration.source){
        case 'xero':
            return routes.xeroSetup;
        case 'qbo':
            return routes.qboSetup;
        case 'financial-cents':
            return routes.financialCentsSetup;
        case 'karbon':
            return routes.karbonSetup;
        case 'client-hub':
            return routes.clientHubSetup;
        case 'keeper':
            return routes.keeperSetup;
        case TaxWorkflow.StanfordTax:
            return routes.stanfordTaxSetup;
        default:
            return routes.availableApps;
    }
}
export function getIntegrationDisplayName(integration, stanfordTaxName) {
    switch(integration.source){
        case 'qbo':
            return 'Quickbooks Online';
        case TaxWorkflow.StanfordTax:
            return stanfordTaxName;
        default:
            return capitalize(integration.source);
    }
}
